import React, { FC, ReactNode } from "react";
import { QueryClientProvider } from "react-query";
import { dataLayer } from "../services/dataLayer";
import { ReactQueryDevtools } from "react-query/devtools";

interface Props {
  children: ReactNode;
}

export const DataLayerProvider: FC<Props> = ({ children }) => (
  <QueryClientProvider client={dataLayer}>
    <ReactQueryDevtools initialIsOpen={false} />
    {children}
  </QueryClientProvider>
);
